<template>
  <form-layout
    class="procedure-form"
    :loading="isUpdatingProceduresList"
    @save="saveProcedures"
  >
    <template #title>
      <h1 class="uppercase">Add Procedure</h1>
    </template>
    <template #body>
      <bdg-checkboxes-list
        name="Procedure list"
        :options="computedProcedures"
        v-model="computedActiveProcedures"
        required
      />
    </template>
  </form-layout>
</template>

<script>
import FormLayout from "../../layouts/FormLayout";
import BdgCheckboxesList from "../../../forms/fields/BdgCheckboxesList";

export default {
  name: "ProcedureForm",
  components: { BdgCheckboxesList, FormLayout },
  props: {
    procedures: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      contractId: parseInt(this.$route.params.id, 10),
      proceduresClone: JSON.parse(JSON.stringify(this.procedures))
    };
  },
  computed: {
    computedProcedures: {
      get() {
        return this.proceduresClone.map(proc => {
          proc.label = proc.title;
          proc.value = Object.assign({}, proc);

          return proc;
        });
      },
      set() {
        // nothing
      }
    },
    computedActiveProcedures: {
      get() {
        return this.computedProcedures
          .filter(proc => proc.is_active)
          .map(proc => proc.value);
      },
      set(val) {
        this.computedProcedures = this.computedProcedures.map(proc => {
          proc.is_active = val.indexOf(proc.value) > -1;
          delete proc.value;
          return proc;
        });
      }
    },
    isUpdatingProceduresList() {
      return this.$store.state.Contracts.Procedures.isUpdatingProceduresList;
    }
  },
  methods: {
    saveProcedures() {
      this.$store.dispatch("updateProceduresList", {
        procedures: this.computedActiveProcedures,
        contractId: this.contractId
      });
    }
  }
};
</script>

<style scoped></style>
